<template>
  <el-dialog
    :close-on-click-modal="false"
    width="500px"
    :title="title"
    :visible.sync="currentVisible"
    @keyup.enter.native="onSubmit()">
    <el-form
      v-if="visible"
      label-position="top"
      ref="form"
      :model="form"
      size="medium">
      <div>
        <el-form-item>
          <remote-select
            v-model="form.customerId"
            @change="customerChange"
            placeholder="请输入客户关键字"
            :query-request="getCustomerTable"
            :find-request="getCustomerDetail"/>
        </el-form-item>
        <el-form-item>
          <remote-select
            v-model="form.projectId"
            @change="projectIChange"
            :disabled="!form.customerId"
            placeholder="请输入项目关键字"
            :query-request="(_)=>getProjectTable(Object.assign(_, {customerid: form.customerId}))"/>
        </el-form-item>
        <el-form-item>
          <remote-select
            multiple
            v-model="form.batchIds"
            :disabled="!form.projectId"
            placeholder="请输入批次关键字"
            label-key="detail"
            id-key="number"
            :query-request="(_)=>getBatchTable(Object.assign(_, {projectid: form.projectId}))"/>
        </el-form-item>
      </div>
      <el-form-item label="配置信息条目">
        <div
          style="margin-bottom: 10px;"
          v-for="(item, index) in form.messages"
          :key="index">
          <el-input v-model="form.messages[index]"
                    style="width: 300px;"
                    placeholder="请输入题目审核不通过信息"
                    @focus="() => focusItem(index)"
                    @blur="() => blurItem(index)"
          ></el-input>
          <el-button
            :disabled="form.messages.length === index + 1"
            size="medium"
            type="danger"
            icon="el-icon-delete"
            @click="removeItem(index)"></el-button>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <!-- <el-button type="text"
                 @click="onReload">重置
      </el-button> -->
      <el-button @click="currentVisible = false">取消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="onSubmit">保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>


export default {
  mixins: [],
  components: {},
  props: {
    customerId: [Number, String],
    batchId: [Number, String],
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      currentVisible: this.visible,
      title: '退单原因配置至其他批次',
      loading: false,
      form: {
        customerId: null,
        projectId: null,
        batchIds: [],
        messages: [''],
      },
    }
  },
  computed: {},
  watch: {
    visible (val) {
      if (this.currentVisible !== this.visible) {
        this.currentVisible = this.visible
      }
    },
    currentVisible () {
      if (this.currentVisible !== this.visible) {
        this.$emit('update:visible', this.currentVisible)
      }
    },
  },
  created () {
    this.onLoad()
  },
  mounted () {},
  destroyed () {},
  methods: {
    ...request.map([
      'getCustomerTable',
      'getCustomerDetail',
      'getProjectTable',
      'getBatchTable',
    ]),
    onSubmit () {
      this.loading = true
      request.alert('saveBatchErrorMsgMultiple', this.getForm()).then((res) => {
        this.$message.success('保存成功！')
      }).finally(() => {
        this.loading = false
      })
    },
    getForm () {
      let form = {}
      form.batch_ids = this.form.batchIds
      form.error_msg = _.filter(this.form.messages)
      return form
    },
    setForm (batchId) {
      return request.alert('getQuestionNotPassMessageDetail', {batch_id: batchId}).then(({data}) => {
        this.form.customerId = this.customerId
        if (data) {
          this.form.messages = data.error_msg || []
          this.form.messages.push('')
        }
      })
    },
    onLoad () {
      return this.setForm(this.batchId)
    },
    // onReload () {
    //   this.loading = true
    //   this.$refs.form.onReload().finally(() => {
    //     this.loading = false
    //   })
    // },
    customerChange () {
      this.form.batchIds = []
      this.form.projectId = null
    },
    projectIChange () {
      this.form.batchIds = []
    },
    removeItem (index) {
      this.form.messages.splice(index, 1)
    },
    focusItem (index) {
      let messages = this.form.messages
      if (!messages[index] && messages.length === index + 1) {
        this.form.messages.push('')
      }
    },
    blurItem (index) {
      let messages = this.form.messages
      if (!messages[index] && messages.length === index + 2) {
        messages.splice(index + 1, 1)
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/question-error-message/components/ConfigQuestionErrorMessageToOtherBatchDialog.vue